import React from "react";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardFooter,
  MDBCardImage,
  MDBCardTitle,
  MDBContainer
} from 'mdb-react-ui-kit';

export class NoticiasGestion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      noticias: []
    };
  }

  componentDidMount() {
    this.getNoticias();
  }

  getNoticias() {
    this.props.onLoading(true);

    doFetch("HAPK", "getAllNews", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(JSON.stringify(data, null, 2));
        this.setState({ noticias: data.DATA });
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  render() {
    return (
      <MDBContainer>
        {this.state.noticias?.map((element, index) => (
          <MDBCard style={{ marginBottom: '20px' }}>
          {element.imagen ?
            <MDBCardImage src={element.imagen} position='top' alt='...' />
            : <></>
          }
          <MDBCardBody>
            <MDBCardTitle>{element.titulo}</MDBCardTitle>
            <div className="d-flex align-items">
              <div style={{ flexShrink: 0 }}>
                <img
                  src={element.imagenAutor}
                  alt=""
                  style={{ width: "45px", height: "45px" }}
                  className="rounded-circle"
                />
              </div>
  
              <div className="ms-3 d-flex flex-column">
                <p className="fw-bold mb-2">{element.nombreAutor}</p>
                <p className="mb-0" style={{ overflowWrap: "break-word", wordBreak: "break-word" }}>
                  {element.noticia}
                </p>
              </div>
            </div>
          </MDBCardBody>
  
          <MDBCardFooter className="d-flex justify-content-between align-items-center text-muted py-3">
            <MDBBtn outline toggle rounded className='mx-2' color='secondary' href="#">Ir a la Noticia</MDBBtn>
  
            <div className="d-flex align-items-center ms-auto">
              <span>{element.fecha}</span>
            </div>
          </MDBCardFooter>
        </MDBCard>
        ))}
      </MDBContainer>
    )
  }

};

export default NoticiasGestion;
